export const JOB_APP_PIN = '1414';
export const PIN_SESSION_KEY = 'lp-job-apps-pin-verified';

export const STATUS_SEQUENCE = ['pending', 'reviewed', 'contacted', 'hired', 'declined'];

export const STATUS_LABELS = {
    pending: 'Pendiente',
    reviewed: 'Revisado',
    contacted: 'Contactado',
    hired: 'Contratado',
    declined: 'Rechazado',
};

export const POSITION_LABELS = {
    baker: 'Panadero',
    cashier: 'Cajero/a',
    decorator: 'Decorador/a',
    kitchen: 'Cocina',
    customer_service: 'Atencion al cliente',
    manager: 'Gerente',
    other: 'Otro',
};

export const STORE_LABELS = {
    kerr_ave: '912 S Kerr Ave',
    college_rd: '2307 N College Rd',
    any: 'Cualquier ubicacion',
};

export const HOURS_LABELS = {
    part_time_10_20: '10-20 hrs (medio tiempo)',
    part_time_20_30: '20-30 hrs (medio tiempo)',
    full_time: '35+ hrs (tiempo completo)',
    flexible: 'Flexible',
};

export const EXPERIENCE_LABELS = {
    none: 'Sin experiencia',
    less_than_1: 'Menos de 1 ano',
    '1_to_3': '1-3 anos',
    '3_to_5': '3-5 anos',
    more_than_5: 'Mas de 5 anos',
};
